import {
  BCard,
  BRow,
  BCol,
  BTable,
  BOverlay,
  BButton,
  BBadge,
  BSpinner,
  BAlert,
  BTooltip,
} from 'bootstrap-vue'
import DisplayStatus from '../../components/core/DisplayStatus'
import DisplayDateTime from '../../components/core/DisplayDateTime'
import DisplayCurrency from '../../components/core/DisplayCurrency'
import DisplayUser from '../../components/core/DisplayUser'
import TableLoader from '../../components/loaders/TableLoader'
import ListPerPage from '../../components/core/list/ListPerPage'
import ListSearch from '../../components/core/list/ListSearch'
import ListPagination from '../../components/core/list/ListPagination'
import ListColumnFilter from '../../components/core/list/ListColumnFilter'
import { getUserData } from '../../auth/utils'
import { EditableMixin } from './edit'
import { downloadFile } from '../utils/utils'

export const ListTable = {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BBadge,
    BTooltip,
    DisplayStatus,
    DisplayDateTime,
    DisplayCurrency,
    DisplayUser,
    ListColumnFilter,
  },
  mixins: [EditableMixin],
  watch: {
    sortBy(value) {
      this.$emit('onSortByChange', value)
    },
    sortDesc(value) {
      this.$emit('onSortDescChange', value)
    },
  },
  props: {
    loader: {
      type: Boolean,
      default: () => true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
    listFilters: {
      type: Object,
      default: () => {},
    },
    sortKey: {
      type: String,
      default: () => 'id',
    },
    sortType: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      selectedId: '',
      columnFields: [],
      routeName: '',
      sortBy: this.sortKey,
      sortDesc: this.sortType,
    }
  },
  computed: {

  },
  methods: {
    // editButtonClicked(item) {
    //   return this.$emit('onEditButtonClicked', item)
    // },
    deleteButtonClicked(item) {
      return this.$emit('onDeleteButtonClicked', item)
    },
    createdItem(createdItem) {
      return this.$emit('onItemCreated', createdItem)
    },
    updatedItem(updatedItem) {
      return this.$emit('onItemUpdated', updatedItem)
    },
    deletedItem(deletedItem) {
      return this.$emit('onItemDeleted', deletedItem)
    },
  },
  created() {
    this.columnFields = this.fields
  },
}
export const ListIndex = {
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    BSpinner,
    BButton,
    BAlert,
    TableLoader,
    ListPerPage,
    ListPagination,
    ListSearch,
  },
  watch: {
    searchKey: 'getData',
    perPage: 'getData',
    page: 'getData',
    sortKey: 'getData',
    sortType: 'getData',
    '$route.params': 'getData',
    '$route.query': 'getData',
  },
  data() {
    return {
      user: getUserData(),
      loader: true,
      excelSpinner: false,
      showOverlay: false,
      startGetData: false,
      page: 1,
      from: 1,
      to: 1,
      perPage: 25,
      total: 1,
      totalPage: 1,
      searchKey: '',
      sortKey: 'id',
      sortType: true,
      // routeName: "",
      customParams: {},
      requestParams: {},
      applyFilters: {},
      commonFields: [],
      adminFields: [],
      userFields: [],
      items: [],
      filters: {},
      additionalData: {
        filters: {},
      },
    }
  },
  computed: {
    fields() {
      if (this.user.is_admin && this.adminFields.length) {
        return this.adminFields
      }
      return this.userFields.length ? this.userFields : this.commonFields
    },
  },
  methods: {
    changePage(value) {
      this.page = value
    },
    changePerPage(value) {
      this.perPage = value
    },
    changeSortKey(value) {
      this.sortKey = value
    },
    changeSortType(value) {
      this.sortType = value
    },
    search(value) {
      if (value.length === 0 || value.length >= 2) this.searchKey = value
    },
    beforeGetData() {},
    getData() {
      this.loader = true
      this.gettingData().then(data => {
        this.page = data.current_page
        this.from = data.from
        this.to = data.to
        this.perPage = data.per_page
        this.total = data.total
        this.totalPage = data.last_page
        this.items = data.items
        if (data.fields) this.commonFields = data.fields
        if (data.additional_data) this.additionalData = data.additional_data
        this.loader = false
      })
    },
    gettingData() {
      return new Promise((resolve, reject) => {
        if (!this.startGetData) {
          this.beforeGetData()
          this.startGetData = true
          const params = {
            page: this.page,
            per_page: this.perPage,
            search_key: this.searchKey,
            sort_key: this.sortKey,
            sort_type: this.sortType ? 'desc' : 'asc',
          }
          this.requestParams = {
            ...this.customParams,
            ...params,
            ...this.$route.query,
            ...this.filters,
          }
          this.$http
            .get(this.routeName, { params: this.requestParams })
            .then(({ data }) => {
              this.afterGetData(data)
              this.startGetData = false
              resolve(data)
            })
            .catch(() => {
              this.startGetData = false
              reject()
            })
        }
      })
    },
    afterGetData() {},
    filterChange(name, value) {
      if (value !== undefined && value !== null) {
        this.filters[name] = value
      } else {
        delete this.filters[name]
      }
    },
    createButtonClicked() {
      const modal = this.routeName.replace('admin/', '')
      return this.$bvModal.show(`modal-${modal}-edit`)
    },
    deleteButtonClicked(item) {
      this.showConfirmDialog().then(() => {
        this.deleteItem(item)
      })
    },
    deleteItem(item) {
      this.showOverlay = true
      this.$http.delete(`${this.routeName}/${item.id}`).then(({ message }) => {
        this.showOverlay = false
        this.showSuccessNotification(message || this.$t('The deletion was successful'))
        this.getData()
        this.showOverlay = false
      }).catch(() => {
        this.showOverlay = false
      })
    },
    downloadExcel() {
      const params = {
        search_key: this.searchKey,
        sort_key: this.sortKey,
        sort_type: this.sortType ? 'desc' : 'asc',
      }
      this.requestParams = {
        ...this.customParams,
        ...params,
        ...this.filters,
      }
      this.excelSpinner = true
      this.$http.get(`${this.routeName}-report`, { params: this.requestParams })
        .then(({ data }) => {
          downloadFile(
            data.file_name,
            data.file_type,
            data.file_content,
          )
          this.excelSpinner = false
        })
        .catch(() => {
          this.excelSpinner = false
        })
    },
    createdItem(createdItem) {
      this.items.push(createdItem)
    },
    updatedItem(updatedItem) {
      const { items } = this
      const index = items.findIndex(
        item => item.id.toString() === updatedItem.id.toString(),
      )
      if (index !== -1) {
        Object.keys(updatedItem).forEach(key => {
          items[index][key] = updatedItem[key]
        })
        this.items = items
      }
    },
    deletedItem(deletedItem) {
      const { items } = this
      const index = items.findIndex(
        item => item.id.toString() === deletedItem.id.toString(),
      )
      if (index !== -1) delete items[index]
      this.items = items
    },
  },
  created() {
    setTimeout(() => {
      this.getData()
    }, 200)
  },
}
